var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-2 d-inline"},[_c('span',{staticClass:"p-0 cursor-pointer it-tabs pb-2 mr-3 bg-transparent",class:_vm.status ? 'active border-0 text-primary' : '',on:{"click":function($event){return _vm.changeThisTab()}}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }